module.exports = __webpack_public_path__ + "img/zlk.f35bf78b.png";